import GoogleLoginButton from 'components/login/GoogleLoginButton';
import PartnerLogo from '../../assets/PartnerLogo';
import React, { useState } from 'react';
import {
  Button,
  Card,
  Col,
  Divider,
  Form,
  Input,
  Layout,
  Row,
  notification
} from 'antd';
import { containerStyles, imageContainer, layoutStyles } from './styles';
import { getTenant, isFeatureEnabled } from 'services/tenants';
import { requestMagicLink } from 'requests/auth';
import { useLogin } from '@refinedev/core';

export interface ILoginForm {
  username: string;
  password: string;
  remember: boolean;
}

interface IMagicLinkForm {
  email: string;
}

export const LoginPage: React.FC = () => {
  const [form] = Form.useForm<ILoginForm>();
  const [magicLinkForm] = Form.useForm<IMagicLinkForm>();
  const { mutate: login, isLoading } = useLogin<ILoginForm>();
  const { googleId, name } = getTenant();
  const [view, setView] = useState<'password' | 'magic-link'>('password');
  const [isMagicLinkLoading, setIsMagicLinkLoading] = useState(false);
  const isDamasioSsoOnly = name === 'damasio';
  const canLoginWithMagicLink = isFeatureEnabled('magic-link-login');

  const handleMagicLinkRequest = async ({ email }: IMagicLinkForm) => {
    try {
      setIsMagicLinkLoading(true);
      await requestMagicLink({ email }).catch(() => null);
    } finally {
      setIsMagicLinkLoading(false);
      setView('password');
      magicLinkForm.resetFields();
      notification.info({
        message: 'Verifique sua caixa de e-mail',
        description:
          'Se este e-mail estiver autorizado, enviaremos um link de acesso. Verifique sua caixa de entrada e spam para continuar.'
      });
    }
  };

  return (
    <Layout style={layoutStyles}>
      <Row
        justify="center"
        align="middle"
        style={{
          height: '100vh'
        }}
      >
        <Col xs={22}>
          <div style={containerStyles}>
            <div style={imageContainer}>
              <PartnerLogo style={{ minWidth: 220, maxWidth: 280 }} />
            </div>
            <Card styles={{ header: { borderBottom: 0 } }}>
              {view === 'magic-link' ? (
                <Form<IMagicLinkForm>
                  layout="vertical"
                  form={magicLinkForm}
                  onFinish={handleMagicLinkRequest}
                  requiredMark={false}
                >
                  <Form.Item
                    name="email"
                    label="E-mail"
                    rules={[{ required: true, type: 'email' }]}
                  >
                    <Input size="large" placeholder="email@empresa.com" />
                  </Form.Item>
                  <Button
                    style={{ marginTop: 12 }}
                    type="primary"
                    size="large"
                    htmlType="submit"
                    loading={isMagicLinkLoading}
                    block
                  >
                    Enviar link de acesso
                  </Button>
                  <Button
                    style={{ marginTop: 8 }}
                    size="large"
                    onClick={() => setView('password')}
                    block
                  >
                    Voltar para login
                  </Button>
                </Form>
              ) : (
                <>
                  {!isDamasioSsoOnly && (
                    <Form<ILoginForm>
                      layout="vertical"
                      form={form}
                      onFinish={values => {
                        login(values);
                      }}
                      requiredMark={false}
                      initialValues={{
                        remember: false
                      }}
                    >
                      <Form.Item
                        name="username"
                        label="Usuário"
                        rules={[{ required: true }]}
                      >
                        <Input size="large" placeholder="usuario" />
                      </Form.Item>
                      <Form.Item
                        name="password"
                        label="Senha"
                        rules={[{ required: true }]}
                      >
                        <Input
                          type="password"
                          placeholder="●●●●●●●●"
                          size="large"
                        />
                      </Form.Item>
                      <Button
                        style={{ marginTop: 32 }}
                        type="primary"
                        size="large"
                        htmlType="submit"
                        loading={isLoading}
                        block
                      >
                        Entrar
                      </Button>
                    </Form>
                  )}
                  {googleId && (
                    <>
                      {!isDamasioSsoOnly && <Divider />}
                      <GoogleLoginButton />
                    </>
                  )}
                  {canLoginWithMagicLink && (
                    <>
                      {(googleId || !isDamasioSsoOnly) && <Divider />}
                      <Button
                        type="default"
                        size="large"
                        onClick={() => setView('magic-link')}
                        block
                      >
                        Entrar com Magic Link
                      </Button>
                    </>
                  )}
                </>
              )}
            </Card>
          </div>
        </Col>
      </Row>
    </Layout>
  );
};
